<template>
  <section class="standard-box-edit modal-backdrop">
    <div
      class="modal-container standard-size"
      role="dialog"
      aria-labelledby="modalTitle"
      aria-describedby="modalDescription"
    >
      <!-- Header -->
      <div class="modal-container__header">
        <h2 class="h1">EDIT DIGITAL KEY BOX</h2>
        <div style="cursor: pointer" @click="close()">
          <v-icon name="times" scale="1.5"></v-icon>
        </div>
        <!-- <h2 class="headerWrap" v-if="secondLanguage">EDITING: {{selectedBoxInfo.titleSec}}</h2>
        <h2 class="headerWrap" v-else>EDITING: {{selectedBoxInfo.title}}</h2> -->
      </div>

      <div class="modal-container__subheader">
        Do you use a digital solution for your door locks? Then you can use this
        box to link directly to their app on App Store or Google Play Store. The
        box for your digital key app will appear below your header text.
      </div>

      <language-adaptive-select
        @change="toggleLanguage"
        :languageTypes="languageTypes"
        :localLanguageTypesIndex="localLanguageTypesIndex"
      />

      <div
        class="modal-container__content"
        v-for="(languageType, key) in languageTypes"
        :key="key"
        v-show="localLanguageTypesIndex === languageType.index"
      >
        <!-- Box Content -->
        <div class="input-group">
          <h3 class="h2">Box Content</h3>
          <GlobalInputTextfield
            label="Box Text"
            :inputId="'text' + key"
            v-model="box.boxTexts[localLanguageTypesIndex]"
            maxlength="50"
          />
          <GlobalInputTextfield
            label="Button Text"
            :inputId="'title' + key"
            v-model="box.buttonTexts[localLanguageTypesIndex]"
            maxlength="30"
          />
        </div>

        <!-- Colors -->
        <div class="input-group">
          <h3 class="h2 colorPickerWrapper">
            Colors
            <div
              v-if="showTextColorPicker"
              class="colorOuterWrap"
              :class="{ changedPickerPosition: changedPickerPosition }"
            >
              <div class="colorInnerWrap">
                <chrome-picker v-model="colors[activeColorPicker]" />
                <button
                  class="color-picker-button"
                  v-on:click="closeColorPicker()"
                >
                  Select
                </button>
                <button
                  class="closeBtn color-picker-button"
                  v-on:click="closeColorPicker()"
                >
                  Close
                </button>
              </div>
            </div>
          </h3>

          <div class="color-input-wrapper" @click="showColorPicker('boxColor')">
            <GlobalInputTextfield
              label="box color"
              :inputId="'boxColor' + key"
              v-model="box.boxColor"
              maxlength="7"
            />
            <div
              class="color-indicator"
              :style="{ backgroundColor: box.boxColor }"
            ></div>
          </div>
          <div
            class="color-input-wrapper"
            @click="showColorPicker('boxTextColor')"
          >
            <GlobalInputTextfield
              label="text color"
              :inputId="'boxTextColor' + key"
              v-model="box.boxTextColor"
              maxlength="7"
            />
            <div
              class="color-indicator"
              :style="{ backgroundColor: box.boxTextColor }"
            ></div>
          </div>
          <div
            class="color-input-wrapper"
            @click="showColorPicker('graphicColor')"
          >
            <GlobalInputTextfield
              label="icon color"
              :inputId="'graphicColor' + key"
              v-model="box.graphicColor"
              maxlength="7"
            />
            <div
              class="color-indicator"
              :style="{ backgroundColor: box.graphicColor }"
            ></div>
          </div>
          <div
            class="color-input-wrapper"
            @click="showColorPicker('buttonColor')"
          >
            <GlobalInputTextfield
              label="Button Color"
              :inputId="'buttonColor' + key"
              v-model="box.buttonColor"
              maxlength="7"
            />
            <div
              class="color-indicator"
              :style="{ backgroundColor: box.buttonColor }"
            ></div>
          </div>
          <div
            class="color-input-wrapper"
            @click="showColorPicker('buttonTextColor')"
          >
            <GlobalInputTextfield
              label="Button Text Color"
              :inputId="'buttonTextColor' + key"
              v-model="box.buttonTextColor"
              maxlength="7"
            />
            <div
              class="color-indicator"
              :style="{ backgroundColor: box.buttonTextColor }"
            ></div>
          </div>

          <div class="counterWrap">
            <div
              v-on:click="showColorPicker('buttonTextColor')"
              v-bind:style="{
                backgroundColor: box.buttonTextColor,
              }"
              class="colorSquare"
            ></div>
          </div>
        </div>

        <!-- Links -->
        <div class="input-group">
          <h3 class="h2">App link</h3>
          <GlobalInputTextfield
            label="Google play store link"
            :inputId="'linka' + key"
            v-model="box.linkAndroid"
          />
          <GlobalInputTextfield
            label="Apple app store link"
            :inputId="'linki' + key"
            v-model="box.linkiOS"
          />
        </div>

        <!-- Buttons -->
        <div class="button-container">
          <button class="button-neutral" @click="btnCancel()">Cancel</button>
          <button
            class="button-positive"
            :disabled="
              box.boxTexts[0].length == 0 ||
              box.boxTexts[1].length == 0
            "
            @click="btnUpdate()"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { db } from "@/firebase";
import { Sketch } from "vue-color";
import GlobalInputTextfield from "@/components/GlobalComponents/GlobalInputTextfield";
import languageObjectMixin from "@/mixins/languageObjectMixin";
import LanguageAdaptiveSelect from '@/components/Ui/LanguageAdaptiveSelect';

export default {
  components: {
    "chrome-picker": Sketch,
    GlobalInputTextfield,
    LanguageAdaptiveSelect
  },
  mixins: [languageObjectMixin],
  props: {
    box: Object,
    completeBoxArray: Array,
    selectedBoxIndex: Number,
  },
  data() {
    return {
      selectedBoxInfo: Object.assign({}, JSON.parse(JSON.stringify(this.box))),
      colors: {
        boxColor: {
          hex: "#194d33",
        },
        boxTextColor: {
          hex: "#194d33",
        },
        graphicColor: {
          hex: "#194d33",
        },
        buttonTextColor: {
          hex: "#194d33",
        },
        buttonColor: {
          hex: "#194d33",
        },
      },
      showTextColorPicker: false,
      activeColorPicker: "",
      showDropdown: false,
      options: [],
      localLanguageTypesIndex: 0,
      languageTypes: [],
    };
  },
  watch: {
    colors: {
      handler() {
        this.box[this.activeColorPicker] = this.colors[
          this.activeColorPicker
        ].hex;
      },
      deep: true,
    },
  },
  created() {
    db.ref(`users/${this.$userId}/languageTypesIndex`).on("value", (data) => {
      this.localLanguageTypesIndex = data.val();
    });
  },
  computed: {
    secondLanguage() {
      if (this.languageTypesIndex === 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted: function () {
    document.addEventListener("keydown", this.closeWindow);
  },
  destroyed: function () {
    document.removeEventListener("keydown", this.closeWindow);
  },
  methods: {
    closeWindow(e) {
      if (e.keyCode == 27) {
        this.showTextColorPicker = false;
        this.close();
      }
    },
    charactersRemaining(string) {
      if (string) {
        return string.length;
      } else {
        return 0;
      }
    },
    close() {
      this.$emit("close");
      this.showTextColorPicker = false;
      this.showDropdown = false;
    },
    closeColorPicker() {
      this.showTextColorPicker = false;
    },
    showColorPicker(activeBox) {
      if (activeBox === "btntext" || activeBox === "btncolor") {
        this.changedPickerPosition = true;
      } else {
        this.changedPickerPosition = false;
      }
      this.showTextColorPicker = true;
      this.activeColorPicker = activeBox;
      this.colors[activeBox].hex = this.box[activeBox];
    },
    btnUpdate() {
      if (!this.box.linkAndroid.includes("play.google")) {
        this.$toasted.show("Provide valid google play store link");
      } else if (!this.box.linkiOS.includes("apps.apple")) {
        this.$toasted.show("Provide valid apple app store link");
      } else {
        this.completeBoxArray[this.selectedBoxIndex] = this.box;
        db.ref(`hotels/${this.$customerId}/${this.$hotelId}/boxes/`).set(
          this.completeBoxArray
        );
        this.close();
        this.$toastEvents.push({
          type: "positive",
          title: "Success",
          content: "The box has been updated",
          id: +new Date(),
        });
      }
    },
    btnCancel() {
      this.close();
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    toggleLanguage(indexClicked) {
      this.localLanguageTypesIndex = Number(indexClicked);
    },
  },
};
</script>

<style scoped>
.modal-container__subheader {
  font-size: 12px;
  color: #aaaaaa;
  max-width: 416px;
}

.input-group .h2 {
  margin-top: 24px;
  margin-bottom: 16px;
}

.icon-image-container {
  display: flex;
}

.icon-image-container__radio-container {
  flex-grow: 0;
  flex-shrink: 0;
}

.icon-image-container__radio-container button {
  margin-bottom: 16px;
  width: 180px;
}

.icon-image-container__icon,
.icon-image-container__image {
  width: 100%;
  display: flex;
}

.icon-image-container__icon .input-dropdown {
  margin-top: 8px;
  margin-bottom: 0;
  width: 100%;
}

.icon-image-container__icon .icon {
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  margin-top: 8px;
  margin-left: 16px;
}

.icon-image-container__image {
  width: 100%;
  height: 120px;
  background-color: var(--grey-light);
  border-radius: var(--border-radius);
}

.icon-image-container__image img {
  width: 100%;
  border-radius: var(--border-radius);
  object-fit: contain;
}

.input-group .input-switch {
  margin-bottom: 20px;
}

.color-input-wrapper {
  position: relative;
}

.color-indicator {
  width: 28px;
  height: 28px;
  position: absolute;
  z-index: 1;
  top: 8px;
  right: 8px;
  border-radius: var(--border-radius);
  border: 2px solid var(--grey);
}

.colorPickerWrapper {
  position: relative;
}

.colorOuterWrap {
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
}

.colorInnerWrap button {
  position: absolute;
  bottom: 5px;
  left: 5px;
  background-color: #48b9ba;
  color: #fff;
  cursor: pointer;
  width: 70px;
  height: 25px;
  border: none;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  transition: 0.1s ease-in;
}
.colorInnerWrap button:hover {
  background-color: #49a39c;
}
.colorInnerWrap button.closeBtn {
  left: 85px;
  background-color: #894e99;
}
</style>
